module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_4.36455454.png";